import { isAbsolutePath } from '../common/components/ctaAnalyticsHoc';
import { FREEDOM_DOMAINS } from '../common/constants';

export const isFreedomDomain = url => {
  // If there is no url returns false
  if (!url) {
    return false;
  }

  // If the url is not an absolute path returns true
  // ex: "/plans" or "/devices", it means it's a relative path in the current domain
  if (!isAbsolutePath(url)) {
    return true;
  }

  // If the url is an absolute path returns true
  // ex: "https://www.freedommobile.ca/" or "https://shop.freedommobile.ca/plans"
  const newUrl = new URL(url);
  return FREEDOM_DOMAINS.some(domain => domain.match(newUrl?.host));
};
